<template>
    <BreadCrumb PageTitle="Liste des forums" />
    <ListeForum />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeForum from "../../components/Forum/ListeForum.vue";

  
    export default defineComponent({
      name: "ListeForumPage",
      components: {
        BreadCrumb,
        ListeForum,
      },
    });
  </script>